import { createAction } from '../util/';

export const reviewOrderToggle = createAction('REVIEW_ORDER', { noPayload: true });
export const isSubmittingToggle = createAction('IS_SUBMITTING', { noPayload: true });
export const hasSubmittedToggle = createAction('HAS_SUBMITTED_TOGGLE', { noPayload: true });
export const setValidationError = createAction('SET_VALIDATION_ERROR');
export const setOrderDetails = createAction('SET_ORDER_DETAILS');
export const setOneTimeAddress = createAction('SET_ONE_TIME_ADDRESS');
export const setCompSapAddress = createAction('SET_COMP_SAP_ADDRESS');
export const setBillableSapAddress = createAction('SET_BILLABLE_SAP_ADDRESS');
export const clearOrderDetails = createAction('CLEAR_ORDER_DETAILS');
export const clearBillableSapAddress = createAction('CLEAR_BILLABLE_SAP_ADDRESS');
export const clearCompSapAddress = createAction('CLEAR_COMP_SAP_ADDRESS');
export const clearOneTimeAddress = createAction('CLEAR_ONE_TIME_ADDRESS');
export const clearAllSelectedAddresses = createAction('CLEAR_ALL_SELECTED_ADDRESSES');

export const reviewOrder = () => dispatch => dispatch(reviewOrderToggle());
